import { IZone } from 'models';

type DownloadDecalResult = {
  data?: File;
  isSuccess: boolean;
};

type SelectedZoneId = string | number;

type DownloadBuildingZoneDecalsProps = {
  selectedZoneIds: SelectedZoneId[];
  zones: IZone[];
  orgSlug: string;
  downloadDecal: (args: { orgSlug: string; id: number; format: 'pdf' }) => Promise<DownloadDecalResult>;
  saveDecal: (args: { data: File; filename: string; type: string }) => void;
};

export const retainSelectedBuildingZoneIds = (selectedZoneIds: SelectedZoneId[], zones: IZone[]): string[] => {
  const availableZoneIds = new Set(zones.map((zone) => String(zone.id)));

  return selectedZoneIds.map(String).filter((zoneId) => availableZoneIds.has(zoneId));
};

export const downloadBuildingZoneDecals = async ({
  selectedZoneIds,
  zones,
  orgSlug,
  downloadDecal,
  saveDecal,
}: DownloadBuildingZoneDecalsProps): Promise<void> => {
  const zoneMap = new Map(zones.map((zone) => [String(zone.id), zone]));
  const downloadableZoneIds = selectedZoneIds.map(String).filter((zoneId) => zoneMap.has(zoneId));

  await Promise.all(
    downloadableZoneIds.map(async (zoneId) => {
      const zone = zoneMap.get(zoneId);
      const result = await downloadDecal({
        orgSlug,
        id: Number(zoneId),
        format: 'pdf',
      });

      if (result.isSuccess && result.data) {
        saveDecal({
          data: result.data,
          filename: `zone_${zone?.code ?? zoneId}_decal.pdf`,
          type: 'application/pdf',
        });
      }
    }),
  );
};
